import { TableBuilderComponent } from './table-builder/table-builder.component';

export const components = [TableBuilderComponent];

export * from './table-builder/table-builder.component';
